import { computed, defineAsyncComponent } from "vue";
import { PAGE_TEMPLATE_TYPES } from "@/templates/_core/templateTypes";
import { useSiteTemplate } from "@/composables/useSiteTemplate";

export function useTemplatePage(pageKey, fallbackLayout = "default") {
  const siteTemplate = useSiteTemplate();

  const pageConfig = computed(() => siteTemplate.resolvePage(pageKey) || {});
  const layoutName = computed(() => pageConfig.value.layout || fallbackLayout);
  const component = computed(() => {
    const config = pageConfig.value;
    if (config.type !== PAGE_TEMPLATE_TYPES.COMPONENT || typeof config.component !== "function") {
      return null;
    }
    return defineAsyncComponent(config.component);
  });
  const isComponentTemplate = computed(() => Boolean(component.value));
  const isLowcodeTemplate = computed(() => pageConfig.value.type === PAGE_TEMPLATE_TYPES.LOWCODE);

  return {
    ...siteTemplate,
    pageConfig,
    layoutName,
    component,
    isComponentTemplate,
    isLowcodeTemplate,
  };
}

export default useTemplatePage;
